(function ($) {
	$(document).ready(function () {
		let pagetop = '#pagetop';

		$(pagetop).hide();
		$(window).on("scroll", function () {
			if ($(this).scrollTop() > 500) {
				$(pagetop).slideDown("fast");
			} else {
				$(pagetop).slideUp("fast");
			}
			let scrollHeight = $(document).height();
			let scrollPosition = $(window).height() + $(window).scrollTop();
			let footHeight = $(".footer__inner").innerHeight();
			if (scrollHeight - scrollPosition <= footHeight) {
				$(pagetop).css({
					"position": "absolute",
					"z-index": "6",
					"bottom": footHeight + 40,
					"right": "0",
					"left": "0",
					"margin": "auto"
				});
			} else { //それ以外の場合は
				$(pagetop).css({
					"position": "fixed",
					"z-index": "6",
					"bottom": "20px",
					"right": "0",
					"left": "0",
					"margin": "auto"
				});
			}
		});
		$(pagetop).click(function () {
			$('body,html').animate({
				scrollTop: 0
			}, 400);
			return false;
		});
	});

	//リキャプチャ
	$(document).ready(function () {
		let grecaptcha = '.grecaptcha-badge';

		$(grecaptcha).hide();
		$(window).on("scroll", function () {
			let scrollHeight = $(document).height();
			let scrollPosition = $(window).height() + $(window).scrollTop();
			let footHeight = $("#footer-copyright").innerHeight();
			if (scrollHeight - scrollPosition <= footHeight) {
				$(grecaptcha).css({
					"bottom": footHeight + 60,
				});
			} else { //それ以外の場合は
				$(grecaptcha).css({
					"bottom": "60px",
				});
			}
		});
	});


	// #で始まるアンカーをクリックした場合にスクロール処理｜aタグclassにnotscrollで回避
	jQuery('a[href^="#"]:not(a.notscroll)').click(function () {
		var speed = 500;
		var href = jQuery(this).attr("href");
		var target = jQuery(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		jQuery("html, body").animate({ scrollTop: position }, speed, "swing");
		return false;
	});

	//ページないリンク｜固定ヘッダーの場合ずらし
	jQuery(function () {
		var windowWidth = $(window).width();
		if (windowWidth <= 1199) {
			var headerHight = 60;
		} else {
			var headerHight = 80;
		}
		jQuery('a[href^="#"].inner-link').click(function () {
			var speed = 200;
			var href = jQuery(this).attr("href");
			var target = jQuery(href == "#" || href == "" ? 'html' : href);
			var position = target.offset().top - headerHight;
			jQuery('body,html').animate({ scrollTop: position }, speed, 'swing');
			return false;
		});
	});

})(jQuery);
